import { gsap } from "gsap";

export const init = () => {
  const banner = document.querySelector(".footer__banner");
  if (!banner) return;

  const trigger = banner.querySelector(".footer__banner__scroll");
  if (!trigger) return;

  const form = banner.querySelector(".footer__banner__form");
  if (!form) return;

  // Al pinchar sobre "trigger" se abre el "form", que está cerrado en altura y opacidad usando GSAP,
  // y si volvemos a pinchar se cierra de nuevo...
  let isOpen = false;
  gsap.set(form, {
    opacity: 0,
    height: 0,
  });

  trigger.addEventListener("click", (e) => {
    e.preventDefault();

    if (isOpen) {
      gsap.to(form, {
        duration: 1,
        opacity: 0,
        height: 0,
        ease: "power2.out",
      });

      gsap.to(trigger, {
        duration: .25,
        rotation: 0,
        ease: "power2.out",
      }, "<");

      isOpen = false;
    } else {
      gsap.to(form, {
        duration: 1,
        opacity: 1,
        height: "auto",
        ease: "power2.out",
      });

      gsap.to(trigger, {
        duration: .25,
        rotation: 180,
        ease: "power2.out",
      }, "<");

      isOpen = true;
    }

    return false
  });
};
